import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme:{
    themes: {
      light: {
        primary: "#4caf50",
        secondary: "#ffc107",
        accent: "#009688",
        error: "#f44336",
        warning: "#ffeb3b",
        info: "#00bcd4",
        success: "#8bc34a"
      },
    },
  }
});
